import { Box } from "@mui/material";
import React, { useEffect } from "react";
import Sidebar from "../../components/SidebarLayout/Sidebar";
import EditDefectDetailsContent from "../../components/Defects/DefectDetails/EditDefectDetailsContent";

const EditDefectDetails = () => {
  return (
    <>
      <Sidebar activeTab="Defects" title="Defects">
        <Box className="globalContainer_For_Content">
          <EditDefectDetailsContent />
        </Box>
      </Sidebar>
    </>
  );
};

export default EditDefectDetails;
